import { render, staticRenderFns } from "./Typo3SubscriptionGrid.vue?vue&type=template&id=6241801b&scoped=true"
import script from "./Typo3SubscriptionGrid.vue?vue&type=script&lang=js"
export * from "./Typo3SubscriptionGrid.vue?vue&type=script&lang=js"
import style0 from "./Typo3SubscriptionGrid.vue?vue&type=style&index=0&id=6241801b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6241801b",
  null
  
)

export default component.exports